export default __webpack_public_path__ + "static/media/Elevate PR - Elevate Secures 25M Investment from Kayne Partners - 2019-06-17.efc418d6.pdf";